import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import { formatTimespent, formatName } from "../../../../services/report.service";

import { Col, Row } from 'react-bootstrap';

import styles from "../../reports.module.scss";
import entityStyles from "./styles.module.scss";

import DefaultAssetIcon from '../../../../images/defaultAsset.jpg';
import numeral from 'numeral';
import Truncate from 'src/components/truncate';
import { Tooltip as ReactTooltip} from 'react-tooltip';
import { localizedStrings } from "../../../../../localization/index"
import Tooltip from 'src/components/tooltip';



class CollectionListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const sections = _.get(this.props.item, 'collection.sectionsCount', 0);
    const assets = _.get(this.props.item, 'collection.assetsCount', 0);
    const shares = _.get(this.props.item, 'analytics.shares', 0);
    const views = _.get(this.props.item, 'analytics.views', 0);

    return (
      <a  href={`/collections/${this.props.item.collection.id}`} target='_blank' className={cx(styles.item, entityStyles.share, this.props.className)}>
        <img className={styles.icon} src={_.get(this.props.item, 'collection.icon.thumbnail') || DefaultAssetIcon} />
        <div>
          <h5 className={styles.title}><Truncate width={300}>{_.get(this.props.item, 'collection.name')}</Truncate></h5>
          <ul className={styles.metrics}>
            <li>{assets} {assets == 1 ? this.localizedKeywords.asset : this.localizedKeywords.assets}</li>
            <li>{views} {views == 1 ? this.localizedTabsCommons.view : this.localizedTabsCommons.views}</li>
            <li>{shares} {shares == 1 ? this.localizedTabsCommons.share : this.localizedTabsCommons.shares}</li>
          </ul>
          <div className={entityStyles.sharedBy}>{this.localizedTabsCommons.created_by}: {formatName(this.props.item.collection.createdBy)}</div>
        </div>
      </a>
    );
  }
}

class CollectionGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }
    
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const sections = _.get(this.props.item, 'collection.sectionsCount', 0);
    const assets = _.get(this.props.item, 'collection.assetsCount', 0);
    const shares = _.get(this.props.item, 'analytics.shares', 0);
    const views = _.get(this.props.item, 'analytics.views', 0);

    return (
      <Row className={cx(styles.row, entityStyles.share)}>
        <Col className={styles.column} md={4}>
          <a href={`/collections/${this.props.item.collection.id}`} target='_blank' className={cx(styles.item, this.props.className)}>
            <img className={styles.icon} src={_.get(this.props.item, 'collection.icon.thumbnail') || DefaultAssetIcon} />
            <div className={styles.collectionsCreatedTitle}>
            <Tooltip content={_.get(this.props.item, 'collection.name')} placement="bottom">
                <h5 className={styles.title}>
                  {_.get(this.props.item, "collection.name")}
                </h5>
              </Tooltip>  <ul className={styles.metrics}>
                {sections > 0 && 
                  <li>{sections} {sections === 1 ? this.localizedKeywords.section : this.localizedKeywords.sections}</li>
                }
                <li>{assets} {assets == 1 ? this.localizedKeywords.asset : this.localizedKeywords.asset}</li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}><Truncate lines={2} >{formatName(this.props.item.collection.createdBy)}</Truncate></Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}>{dateformat(this.props.item.collection.createdDate, 'dd mmm yyyy')}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}>{dateformat(this.props.item.collection.modifiedDate, 'dd mmm yyyy')}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={1}>{shares}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={1}>{views}</Col>
      </Row>
    );
  }
}

const Collection = {};
Collection.List = CollectionListItem;
Collection.Grid = CollectionGridItem;

export default Collection;